import * as Sentry from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import posthog from "posthog-js";

Sentry.init({
  dsn: "https://d1c50adaefc96d02810e889b8af17c3d@o4508333141917696.ingest.us.sentry.io/4508333143490560",
  tracesSampleRate: 1,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});

function PosthogInit() {
  useEffect(() => {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
      api_host: "https://tikka.lowcodeplugins.com",
      ui_host: "https://eu.posthog.com",
      person_profiles: "identified_only",
      loaded: function (ph) {
          ph.opt_out_capturing();
      },
      autocapture: false,
      disable_session_recording: true,
      capture_pageview: false,
    });
    posthog.debug(true);
  }, []);

  return null;
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
      <PosthogInit />
    </StrictMode>,
  );
});
